import type { NotificationType } from "@/@sdk/notifications/notifications.models";
import {
  AtSign,
  CheckCircle2,
  CreditCard,
  Info,
  Mail,
  ThumbsUp,
  type LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

const ICON_BY_TYPE: Record<NotificationType, LucideIcon> = {
  DISCUSSION_MENTION: AtSign,
  INBOUND_EMAIL: Mail,
  DEPOSIT_PAID: CreditCard,
  BOOKING_CONFIRMED: CheckCircle2,
  BOOKING_ACCEPTED: ThumbsUp,
  SYSTEM: Info,
};

export function NotificationTypeIcon({
  type,
  className,
}: {
  type: NotificationType;
  className?: string;
}) {
  const Icon = ICON_BY_TYPE[type] ?? Info;
  return <Icon className={cn("h-4 w-4 shrink-0 text-muted-foreground", className)} />;
}
